import { Expose } from 'class-transformer';

export class CreditUsageAllocDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'date' })
  date: string;
  @Expose({ name: 'start_time' })
  startTime: number;
  @Expose({ name: 'end_time' })
  endTime: number;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'to_date' })
  toDate: number;
}
